<template>
  <v-text-field
      :type="type"
      :min="min"
      :max="max"
      :disabled="disabled"
      :value="value"
      :label="label"
      :prefix="prefix"
      :outlined="outlined"
      :dense="dense"
      :name="name"
      :readonly="readonly"
      :prepend-icon="prependIcon"
      :required="required"
      :loading="loading"
      :clearable="clearable"
      @input="$emit('input', $event)"
      v-on="$listeners"
      :autocomplete="!autocomplete ? 'new-password' : ''"
      class="m-text-field"
      :error-messages="errorMessages"
      :style="inputHeightStyle"
      :hide-details="hideDetails"
  >

    <template #append>
      <slot name="append"/>
    </template>
    <template #append-outer>
      <slot name="append-outer"/>
    </template>
    <template #prepend>
      <slot name="prepend"/>
    </template>

  </v-text-field>
</template>

<script>
export default {
  name: "m-text-field",
  props: {
    type: String,
    min: [String, Number],
    max: [String, Number],
    disabled: Boolean,
    value: [String, Number],
    label: String,
    prefix: String,
    outlined: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    errorMessages: Array,
    name: String,
    prependIcon: String,
    required: Boolean,
    readonly: Boolean,
    loading: Boolean,
    clearable: Boolean,
    autocomplete: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 48
    }
  },
  computed: {
    inputHeightStyle() {
      const height = typeof this.height === 'number'
          ? `${this.height}px`
          : this.height;

      return {
        '--input-height': height,
        '--label-top': this.outlined ? `${height ?? 48 / 3.4}px` : '50%',
        '--label-active-top': this.outlined ? '18px' : '0'
      };
    }
  }
}
</script>
<style scoped>
.m-text-field ::v-deep(.v-input__slot) {
  height: var(--input-height, 48px) !important;
  min-height: var(--input-height, 48px) !important;
  border-radius: 6px;
  margin-bottom: 2px;
}

.m-text-field:deep(.v-label){
  top: var(--label-top, 14px);
  font-family: Open Sans, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0;
  vertical-align: middle;
  color: #A6ADB5 !important;
}

.m-text-field ::v-deep(.v-input.v-input--is-outlined:not(.v-input--is-focused) fieldset) {
  border: 1px solid var(--basic-grey);
}

.m-text-field ::v-deep(.v-input.v-input--is-outlined.v-input--is-focused fieldset) {
  border: 1px solid #8486D3 !important;
}



.m-text-field :deep(.v-label--active){
  top: var(--label-active-top, 18px);
  color: #78818B !important;
}

.m-text-field :deep(.v-label--active.primary--text){
  top: var(--label-active-top, 18px);
  color: #8486D3 !important;
}

.m-text-field :deep(.v-label--active.error--text){
  top: 18px;
  color: #E77985 !important;
}

.m-text-field ::v-deep(input){
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0;
  vertical-align: middle;
  color: var(--black);
}

.m-text-field ::v-deep(.v-messages__message){
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 10px;
  line-height: 130%;
  letter-spacing: 0;
}
</style>


<style lang="scss">
// Костыль перенести в vuetify.js
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state):not(.v-input--is-disabled)
> .v-input__control
> .v-input__slot:hover
fieldset {
  color:  var(--dark-grey);
}

.v-text-field--outlined.v-input--is-focused fieldset, .v-text-field--outlined.v-input--has-state fieldset {
  border: 1px solid currentColor;
}

.v-text-field--outlined.v-input--is-label-active:not(.v-input--is-focused):not(.error--text)
> .v-input__control
> .v-input__slot
fieldset {
  border-color: var(--dark-grey);
}

.v-text-field.v-text-field--enclosed .v-text-field__details{
  margin-bottom: 4px;
}
.v-input__append-inner{
  margin: auto 0 !important;
}
</style>
